export function getRedemptionElement(id, usdc, status) {
    let statusText;
    let statusColor;
    let statusIcon;

    if (status === 0) {
        statusText = 'Processing';
        statusColor = 'rgba(255, 214, 0, 1)'; // Yellow color
        statusIcon = (
            <svg className="w-4 h-4 inline-block mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 00-2 0v4a1 1 0 001 1h2a1 1 0 100-2h-1V5z" clipRule="evenodd"></path>
            </svg>
        );
    } else if (status === 2) {
        statusText = 'Success';
        statusColor = 'rgba(38, 221, 249, 1)'; // Green color
        statusIcon = (
            <svg className="w-4 h-4 inline-block mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm4.293-9.293a1 1 0 00-1.414-1.414L9 10.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
            </svg>
        );
    } else if (status === 1) {
        statusText = 'Canceled';
        statusColor = 'rgba(255, 95, 82, 1)'; // Red color
        statusIcon = (
            <svg className="w-4 h-4 inline-block mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L10 8.586 7.707 6.293a1 1 0 00-1.414 1.414L8.586 10l-2.293 2.293a1 1 0 101.414 1.414L10 11.414l2.293 2.293a1 1 0 001.414-1.414L11.414 10l2.293-2.293z" clipRule="evenodd"></path>
            </svg>
        );
    }

    return (
        <tr key={id}>
            <td className="px-4 py-2 text-[rgba(255,255,255,1)] font-medium text-[18px]">{id}</td>
            <td className="px-4 py-2 text-[rgba(255,255,255,1)] font-medium text-[18px]">{usdc}</td>
            <td className="px-4 py-2">
                <p style={{ color: statusColor }} className="text-[18px] font-medium flex items-center">
                    {statusIcon}
                    {statusText}
                </p>
            </td>
        </tr>
    );
}
